class MindKeyboard {
    constructor(type,key,shortcutKey,describe) {
        this.type = type;
        this.key = key;
        this.shortcutKey = shortcutKey;
        this.describe = describe;
    }
}
export default MindKeyboard